"use strict";

function ManitobaMiniLicense() {
  this.node = null;
  this.id = null;
  this.declaredClass = null;
  this.extends = [_MoneyController];

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    this._viewHighCostOfferMessage();
  };
}